module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "upper-subpanel--inside"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "with-child-centered"
  }, [_c('h5', [_vm._v("請輸入藥物名稱")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query),
      expression: "query"
    }],
    ref: "input",
    staticClass: "form-control drug-search-input",
    attrs: {
      "type": "text",
      "id": "drug-name",
      "name": "drug_name",
      "placeholder": "輸入藥物名稱"
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "btn control-button-red",
    on: {
      "click": function($event) {
        _vm.query = ''
      }
    }
  }, [_vm._v("重新輸入")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [(_vm.query_result) ? _c('div', {
    staticClass: "drug-search-list drug-search-list--large",
    attrs: {
      "id": "drug-search-list"
    }
  }, _vm._l((_vm.query_result), function(drug) {
    return _c('div', {
      staticClass: "btn drug-button",
      on: {
        "click": function($event) {
          return _vm.setDrug(drug.id)
        }
      }
    }, [_c('h6', [_c('span', [_vm._v("[ \n            "), (drug.CGMH_number !== null) ? _c('span', [_vm._v(_vm._s(drug.CGMH_number) + " - ")]) : _vm._e(), _vm._v("\n            " + _vm._s(drug.code) + " ]\n          ")]), _vm._v(" \n          " + _vm._s(drug.product_name) + "\n        ")]), _vm._v(" "), _c('span', {
      staticClass: "drug-generic-name"
    }, [_vm._v(_vm._s(drug.generic_name))])])
  }), 0) : _c('div', {
    staticClass: "with-child-centered"
  }, [_c('h5', [_vm._v("未搜尋到任何藥物")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9704d750","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/flowComp/DrugSelection.vue
// module id = 1526
// module chunks = 1